import styled from 'styled-components'

export const StyledCategoryAdmin = styled('div')`
  .sub-cat {
    margin-left: 30px;
  }

  .dragging {
    opacity: 0.5;
  }

  .add-new {
    min-width: 400px;
    padding-top: 40px;

    .ant-form {
      display: flex;
      position: relative;
      flex-direction: row;
      width: 100%;
    }
  }

  .scrolltop {
    position: fixed;
    bottom: 20px;
    right: 20px;
  }
`

export const StyledDraggable = styled('div')`
  .dragging {
    opacity: 0.5;
    transition: opacity 0.2s ease;
    transform: scale(1);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    max-width: 600px;
  }
`

export const StyledDroppable = styled('div')`
    .drop-area {
        position: relative;
    }

    .drop-area.drop-top::before,
    .drop-area.drop-bottom::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        height: 3px;
        background-color: ${(props) => props.theme.colorPrimary};
        border-radius: 2px;
        z-index: 10;
        max-width: 600px;
    }

    .drop-area.drop-top::before {
        top: 0;
        transform: translateY(-50%);
    }

    .drop-area.drop-bottom::after {
        bottom: 0;
        transform: translateY(50%);
    }
`
